import getSvgIcon from '../../helpers/getSvgIcon';

/**
 * Specifies the icon of the open/close sign in the tree column
 * @param instance
 * @returns {(function(*): (string|string))|*}
 */
export default instance => task => {
  const expanded = getSvgIcon('minus-2', 'regular', 16);
  const collapsed = getSvgIcon('plus-3', 'regular', 16);

  if (task.type === instance.config.types.project) {
    return `<div class="gantt_tree_icon gantt_${task.$open ? 'close' : 'open'}">
        <div class="gantt_tree_icon_item">${task.$open ? expanded : collapsed}
        </div>
      </div>`;
  }

  return "<div class='gantt_tree_icon'><div class='gantt_tree_icon_item'></div></div>";
};
